"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubModeGestionUtiliseCorporation = void 0;
exports.ESubModeGestionUtiliseCorporation = {
    direct: "direct",
    conseillee: "conseillee",
    sous_mandat: "sous_mandat",
};
